import { createMuiTheme } from '@material-ui/core';

export const theme = createMuiTheme({
  palette: {
    type: 'dark'
  },
});

export const themeInvert = createMuiTheme({
  palette: {
    type: 'light'
  },
});


// WEBPACK FOOTER //
// ./src/theme.ts